<template>
  <!-- Container -->
  <div>
    <a href="#" @click.prevent.stop="showProfile">
      <svg id="editIcon" viewBox="0 0 29.31 29.26" style="enable-background:new 0 0 29.31 29.26;" xml:space="preserve"><path class="st3" d="M28.36,2.12l-1.17-1.17c-1.26-1.27-3.32-1.27-4.59,0L21.26,2.3c0,0,0,0,0,0s0,0,0,0L9.54,14.01 c-0.01,0.01-0.02,0.03-0.03,0.04c-0.05,0.05-0.08,0.11-0.11,0.17c-0.03,0.06-0.07,0.11-0.09,0.17c-0.01,0.02-0.02,0.03-0.02,0.04 L7.5,20.57c-0.1,0.35,0,0.73,0.25,0.99c0.19,0.19,0.45,0.29,0.71,0.29c0.09,0,0.19-0.01,0.28-0.04l6.13-1.79 c0.02-0.01,0.03-0.02,0.05-0.03c0.06-0.02,0.12-0.06,0.18-0.09c0.06-0.03,0.11-0.06,0.16-0.11c0.01-0.01,0.03-0.02,0.04-0.03 L27.02,8.06c0,0,0,0,0,0s0,0,0,0l1.34-1.34C29.63,5.45,29.63,3.39,28.36,2.12z M21.96,4.42l2.93,2.93l-10.3,10.3l-2.93-2.93 L21.96,4.42z M10.74,16.62l1.96,1.96l-2.76,0.8L10.74,16.62z M26.95,5.3l-0.64,0.64L23.38,3l0.64-0.64c0.48-0.48,1.27-0.48,1.76,0 l1.17,1.17C27.43,4.02,27.43,4.81,26.95,5.3z"/><path class="st3" d="M25.48,16.27c-0.55,0-1,0.45-1,1v5.51c0,2.48-2.01,4.49-4.49,4.49H6.49C4.01,27.26,2,25.25,2,22.77V9.27 c0-2.47,2.01-4.49,4.49-4.49H12c0.55,0,1-0.45,1-1s-0.45-1-1-1H6.49C2.91,2.78,0,5.69,0,9.27v13.51c0,3.58,2.91,6.49,6.49,6.49H20 c3.58,0,6.49-2.91,6.49-6.49v-5.51C26.48,16.72,26.04,16.27,25.48,16.27z"/></svg>
    </a>
    <!-- Modal -->
    <b-modal v-model="modalShow" hide-footer centered title="Profil Utilisateur" v-if="modalShow">
      <!-- Form Profile -->
      <ProfileType :old-user="user" v-if="modalShow" @profileUpdated="hideProfile" @updateUsers="updateUsers"/>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ShowUserProfileButton',
  props: {
    user: { type: Object, required: true },
  },
  data() {
    return {
      modalShow: false,
    };
  },
  watch: {
    modalShow(newValue) {
      this.$store.commit('setProfileModalShow', newValue);
    },
  },
  methods: {
    showProfile() {
      this.modalShow = true;
    },
    hideProfile() {
      this.modalShow = false;
    },
    updateUsers(users) {
      this.modalShow = false;
      this.$emit('updateUsersTable', users)
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#editIcon {
  fill: #005EB8;
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/button/ShowUserProfileButton.vue